/**
 * Renders text but replaces every "&" character with a clean sans-serif glyph.
 * Use inside Playfair (font-display) headlines where the decorative serif
 * ampersand looks out of place.
 *
 * Usage: <Amp>Shopify & eCommerce</Amp>
 */
export const Amp = ({ children }) => {
  if (typeof children !== 'string') return children;
  const parts = children.split('&');
  return parts.map((part, i) => (
    <span key={i}>
      {part}
      {i < parts.length - 1 && <span className="amp">&</span>}
    </span>
  ));
};
